<template>
  <router-view />
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'App',
  methods: {
    ...mapMutations('quiz', {
      getPokemons: 'getPokemons'
    })
  },
  mounted() {
    this.getPokemons()
  }
}
</script>

<style></style>
